export default __webpack_public_path__ + "static/media/body-background.7d7d88a8.png";